// src/routers/AdministrativeRouter.js
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuthRole from '../Hooks/useAuthRole'; // ✅ use the role hook (administrative OR above)

const AdministrativeRouter = ({ children, ...rest }) => {
  const { user, isLoading, isAdministrativePlus } = useAuthRole();
  // isAdministrativePlus === administrative OR operator OR moderator OR admin

  if (isLoading) {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  const isSignedIn = !!user?.email;
  const canAccess = isSignedIn && isAdministrativePlus; // ✅ allow operator/moderator/admin too

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default AdministrativeRouter;
